<div class="d-flex px-md-5 px-2 justify-content-center sc-assistance">
  <div class="col-lg-11">
    <div class="dash-panel">
      <h3 class="dash-section-title">Assistance</h3>

      <form class="row g-4" [formGroup]="ContactForm" (ngSubmit)="onSubmit()">

        <div class="col-lg-4">
          <p class="sc-subtitle">Contact us</p>

          <div class="mb-3">
            @if (user.first_name === undefined) {
              <input type="text" formControlName="ContactName" class="form-control" placeholder="Name">
            }
          </div>
          <div class="mb-3">
            @if (user.email === undefined) {
              <input type="email" formControlName="ContactEmail" class="form-control" placeholder="E-mail">
            }
          </div>

          @if (user.first_name !== undefined) {
            <div class="sc-inline-field">
              <span class="sc-inline-label">Name</span>
              <span class="text-muted">{{user.first_name}} {{user.last_name}}</span>
            </div>
          }
          @if (user.email !== undefined) {
            <div class="sc-inline-field">
              <span class="sc-inline-label">Response mail</span>
              <span class="text-muted">{{user.email}}</span>
            </div>
          }

          <label class="sc-field-label d-block mt-3">Subject</label>
          <select formControlName="ContactSubject" class="form-select">
            <option value="" disabled>Choose Subject</option>
            @for (supportSubjectType of supportSubjectTypes; track supportSubjectType) {
              <option [value]="supportSubjectType">
                {{SupportSubjectToLabelMapping[supportSubjectType]}}
              </option>
            }
          </select>

          <div class="form-check pt-3">
            <input class="form-check-input me-2" type="checkbox" formControlName="contactCopy" id="flexCheckChecked">
            <label class="form-check-label" for="flexCheckChecked">
              Send me a copy of this message
            </label>
          </div>

          <div class="mt-3">
            <button type="submit" [disabled]="!this.ContactForm.valid" class="btn btn-sm btn-primary">
              Submit
            </button>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="form-group h-100">
            <textarea class="form-control h-100" formControlName="ContactMessage" rows="8"
              placeholder="Message"></textarea>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
